<template>
  <button type="button" class="options-menu-row" :class="{ 'options-menu-row--pro': pro }" @click="$emit('select')">
    <span class="options-menu-row__icon" aria-hidden="true">
      <span class="material-icons">{{ icon }}</span>
    </span>
    <span class="options-menu-row__label">{{ label }}</span>
  </button>
</template>

<script setup>
// One entry in an OptionsMenuModal. PRO+ tools tint their icon tile instead of carrying a badge
// each; the section label above them says PRO+ once.
defineProps({
  icon: { type: String, required: true },
  label: { type: String, required: true },
  pro: { type: Boolean, default: false },
});
defineEmits(['select']);
</script>

<style scoped>
.options-menu-row {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 12px;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

/* A rule between rows, matching the list dividers used elsewhere on the site. Drawn as a pseudo-element
   so it can be inset to line up with the icon and label rather than spanning the rounded hover background. */
.options-menu-row + .options-menu-row::before {
  content: '';
  position: absolute;
  top: 0;
  right: 12px;
  left: 12px;
  height: 1px;
  background: #434343;
}

.options-menu-row:hover {
  background: rgba(255, 255, 255, 0.06);
}

.options-menu-row:focus-visible {
  outline: 2px solid var(--yellow, #fddf00);
  outline-offset: -2px;
}

.options-menu-row__icon {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: rgba(253, 223, 0, 0.1);
}

.options-menu-row__icon .material-icons {
  font-size: 19px;
  color: var(--yellow, #fddf00);
}

.options-menu-row--pro .options-menu-row__icon {
  background: rgba(52, 200, 255, 0.12);
}

.options-menu-row--pro .options-menu-row__icon .material-icons {
  color: #34c8ff;
}

.options-menu-row__label {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
